import { render } from "./indexUser.vue?vue&type=template&id=22e27d71&scoped=true"
import script from "./indexUser.vue?vue&type=script&lang=js"
export * from "./indexUser.vue?vue&type=script&lang=js"

import "./indexUser.vue?vue&type=style&index=0&id=22e27d71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e27d71"]])

export default __exports__